import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SessionCalendarNewContainer from "./sessionCalendarNew/sessionCalendarNew.container";
import {
  PageContainer,
  Header,
  HeaderIcon,
  HeaderContent,
  Title,
  Subtitle,
  StatsContainer,
  StatCard,
  StatNumber,
  StatLabel,
  CalendarSection,
} from "./homeNew.styled";

const HomeNewView = (props) => {
  const { t } = useTranslation();
  const { requestData, stats } = props;

  return (
    <PageContainer>
      {/* Header */}
      <Header>
        <HeaderIcon>
          <i className="fas fa-calendar-alt"></i>
        </HeaderIcon>
        <HeaderContent>
          <Title>{t("homeNew.title")}</Title>
          <Subtitle>{t("homeNew.subtitle")}</Subtitle>
        </HeaderContent>
      </Header>

      {/* Stats Cards */}
      {/* <StatsContainer>
        <StatCard $color="#f9ae17">
          <StatNumber>{stats.totalSessions}</StatNumber>
          <StatLabel>{t("homeNew.stats.totalSessions")}</StatLabel>
        </StatCard>

        <StatCard $color="#203b34">
          <StatNumber>{stats.upcomingSessions}</StatNumber>
          <StatLabel>{t("homeNew.stats.upcomingSessions")}</StatLabel>
        </StatCard>

        <StatCard $color="#f9ae17">
          <StatNumber>{stats.courseCategories}</StatNumber>
          <StatLabel>{t("homeNew.stats.courseCategories")}</StatLabel>
        </StatCard>
      </StatsContainer> */}

      {/* Calendar */}
      <CalendarSection>
        <SessionCalendarNewContainer sessions={requestData} />
      </CalendarSection>
    </PageContainer>
  );
};

HomeNewView.propTypes = {
  requestData: PropTypes.array,
  stats: PropTypes.shape({
    totalSessions: PropTypes.number,
    upcomingSessions: PropTypes.number,
    courseCategories: PropTypes.number,
  }),
};

export default HomeNewView;
